<app-loader *ngIf="loader"></app-loader>
<div id="rootTree" (change)="updateView($event)"></div>
